export default {
	"address.buttonClick": "按鈕點擊",
	"address.edit": "編輯",
	"address.New": "新增",
	"address.NewRevenueAddress": "新增收貨位址"
}